// extracted by mini-css-extract-plugin
module.exports = {"arrowButton":"buttons-module--arrowButton--3lG4R","crossButton":"buttons-module--crossButton--4fOBW"};